import SearchController from './search_controller'

export default class extends SearchController {
  filter (e) {
    this.stimulate('ActivityReflex#filter', e.target)
  }
}
